import React from 'react';

import { useChatClient } from '../ChatClient/ChatClient';
import { useClient } from '../Client/Client';
import { ChatUserContextType } from './types';

type ChatUserProviderProps = {
  children: React.ReactNode;
};

export const ChatUserContext =
  React.createContext<ChatUserContextType>(undefined);

export const ChatUserProvider: React.FC<ChatUserProviderProps> = ({
  children,
}) => {
  const [chatMe, setChatMe] = React.useState<ChatUserContextType>(undefined);
  const { chatConnect } = useChatClient();
  const { get } = useClient();
  const { status } = useClient();

  React.useEffect(() => {
    if (status === 'authenticated') {
      get(
        '/me',
        (user: ChatUserContextType) => {
          if (user) {
            setChatMe(user);
            chatConnect(user.id);
          }
        },
        () => {
          console.error('Erreur lors de la connexion au messagerie');
        },
        {
          isChatServer: true,
        }
      );
    } else {
      setChatMe(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  return (
    <ChatUserContext.Provider value={chatMe}>
      {children}
    </ChatUserContext.Provider>
  );
};

export const useChatUser = () => React.useContext(ChatUserContext);
